import "./cursor-follow";
import "./alpine";
import "./sliders";

const clipPathEls = document.querySelectorAll<HTMLElement>("[data-clip]");

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const clipType = (entry.target as HTMLElement).dataset.clip;

    let origin;
    let elementWidth;
    let elementHeight;
    let curveX;
    let curveY;
    let curveX1;
    let curveY1;
    let curveX2;
    let curveY2;

    origin = 0;
    elementWidth = entry.borderBoxSize[0].inlineSize;
    elementHeight = entry.borderBoxSize[0].blockSize * 0.975;

    curveX = origin;
    curveY = elementHeight;

    switch (clipType?.toString()) {
      case "1":
        curveX1 = elementWidth * 0.5;
        curveY1 = elementHeight * 0.9074;
        curveX2 = elementWidth * 0.5;
        curveY2 = elementHeight * 1.0925;
        break;
      case "2":
        curveX1 = elementWidth * 0.5;
        curveY1 = elementHeight * 1.0925;
        curveX2 = elementWidth * 0.5;
        curveY2 = elementHeight * 0.9074;
        break;
      default:
        curveX1 = elementWidth * 0.6666;
        curveY1 = elementHeight * 0.9074;
        curveX2 = elementWidth * 0.3333;
        curveY2 = elementHeight * 1.0925;
        break;
    }

    if (window.innerWidth < 1280) {
      elementHeight = entry.borderBoxSize[0].blockSize;

      curveX1 = origin;
      curveX2 = origin;
      curveY1 = elementHeight;
      curveY2 = elementHeight;
      curveY = elementHeight;
    }

    (
      entry.target as HTMLElement
    ).style.clipPath = `path('M ${origin} ${origin} L ${elementWidth} ${origin} L ${elementWidth} ${elementHeight} C ${curveX1} ${curveY1} ${curveX2} ${curveY2} ${curveX} ${curveY} Z')`;
  }
});

clipPathEls.forEach((clipPathEl) => {
  resizeObserver.observe(clipPathEl);
});

document.addEventListener("DOMContentLoaded", function () {
  var links = document.getElementsByTagName("a");
  for (var i = 0; i < links.length; i++) {
    if (links[i].host !== window.location.host) {
      links[i].setAttribute("target", "_blank");
      links[i].setAttribute("rel", "noopener noreferrer"); // Recommended for security
    }
  }
});

jQuery(document).ready(function ($) {
  $("img[title]").each(function () {
    $(this).removeAttr("title");
  });
});
